import React, { Component } from 'react';
import { Button, Popconfirm, message } from 'antd';
import UpdateModal from './UpdateClinicalTrialExp';
import { ProDetail } from './Widget';
import ComTable from '../ComTable';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class ClinicalTrialExp extends Component {
    state = {
        data: [],
        config: [],
        pagination: {
            offset: 1,
            pageSize: 10,
        },
        loading: false,
    }

    componentDidMount() {
        const config = [{
            zh: '项目领域',
            en: 'Therapeutic Area',
            key: 'investigationAreaName',
            width: 140,
        }, {
            zh: '疾病',
            en: 'Indications',
            key: 'diseaseName',
            width: 140,
        }, {
            zh: '项目角色',
            en: 'Role',
            key: 'clinicalRoleName',
            width: 70,
        }, {
            zh: '项目类型',
            en: 'Study Type',
            key: 'clinicalTypeName',
            width: 140,
        }, {
            zh: '参与时间',
            en: 'Time',
            key: 'joinTime',
            width: 120,
            render: (text, record) => {
                const { childrens } = record;
                if (childrens && childrens.every(i => i.experienceType !== 'NON_MEDKEY')) {
                    return <a onClick={() => this.showDetail(record)}>{text}</a>;
                } else {
                    return text;
                }
            }
        }, {
            zh: '研究产品类型',
            en: 'Investigational Product Type',
            key: 'investigationProductName',
        }, {
            zh: '项目分期',
            en: 'Study Phase',
            key: 'investigationProductStageName',
            width: 110,
        }];
        this.setState({ config }, () => {
            this.loadData();
        });
    }

    loadData = () => {
        const { userId } = this.props;
        const { pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.queryVitaeClinicalExperience,
            data: {
                userId,
                offset: current,
                limit: pageSize,
            },
            dataType: 'json',
            doneResult: res => {
                const { data = [], totalCount = 0 } = res;
                pagination.total = totalCount;

                this.setState({
                    pagination,
                    loading: false,
                    data,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    update = (record) => {
        this.ref.show(record);
    }

    delete = (vitaeClinicalExperienceId) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.deleteVitaeClinicalExperience,
            data: { vitaeClinicalExperienceId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleTableChange = ({ pagination }) => {
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    getOperate = () => {
        const { isChinese } = this.props;
        return {
            title: '操作',
            key: 'operate',
            width: isChinese ? 80 : 60,
            render: (text, row) => {
                const { vitaeClinicalExperienceId, diseaseRemarkChinese, childrens, clinicalRoleCommentsChinese, investigationProductStageRemarkChinese } = row;
                if (isChinese) {
                    if ((childrens || []).some(i => i.experienceType === 'MEDKEY')) {
                        return <span className="jinshi">自动</span>;
                    } else if ((childrens || []).every(i => i.experienceType === 'NON_MEDKEY')) {
                        return (
                            <span>
                                <a onClick={() => this.update(row)}>修改</a>
                                <span className="ant-divider" />
                                <Popconfirm title="确定要删除吗?" onConfirm={() => this.delete(vitaeClinicalExperienceId)}>
                                    <a>删除</a>
                                </Popconfirm>
                            </span>
                        );
                    } else {
                        return '-';
                    }
                } else {
                    return (
                        !(diseaseRemarkChinese || investigationProductStageRemarkChinese || clinicalRoleCommentsChinese) ?
                            '-'
                        :
                            <span>
                                <a onClick={() => this.update(row)}>修改</a>
                            </span>
                    ); 
                }
            }
        };
    }

    getDataSource = () => {
        const { data } = this.state;
        const { isChinese } = this.props;
        const dataSource = data.map((item, index) => {
            const {
                investigationAreaName,
                investigationAreaEnglishName,
                diseaseName,
                diseaseEnglishName,
                diseaseRemarkChinese,
                diseaseRemarkEnglish,
                clinicalRoleName,
                clinicalRoleEnglishName,
                clinicalTypeName,
                clinicalTypeEnglishName,
                clinicalStartTime,
                clinicalEndTime,
                investigationProductName,
                investigationProductEnglishName,
                secondInvestigationProductEnglishName,
                secondInvestigationProductName,
                investigationProductStageName,
                investigationProductStageEnglishName,
                investigationProductStageRemarkChinese,
                investigationProductStageRemarkEnglish,
                clinicalRoleCommentsChinese,
                clinicalRoleCommentsEnglish,
            } = item;
            const diseaseRemark = isChinese ? diseaseRemarkChinese : diseaseRemarkEnglish;
            const clinicalRoleComments = isChinese ? clinicalRoleCommentsChinese : clinicalRoleCommentsEnglish;
            const investigationProductStageRemark = isChinese ? investigationProductStageRemarkChinese : investigationProductStageRemarkEnglish;
            return {
                index: index + 1,
                ...item,
                investigationAreaName: isChinese ? investigationAreaName : investigationAreaEnglishName,
                diseaseName: `${isChinese ? diseaseName : diseaseEnglishName}${diseaseRemark ? `(${diseaseRemark})` : ''}`,
                clinicalRoleName: `${isChinese ? clinicalRoleName : clinicalRoleEnglishName}${clinicalRoleComments ? `(${clinicalRoleComments})` : ''}`,
                clinicalTypeName: isChinese ? clinicalTypeName : clinicalTypeEnglishName,
                joinTime: `${clinicalStartTime.slice(0, 7)}~${clinicalEndTime ? clinicalEndTime.slice(0, 7) : isChinese ? '至今' : 'Present'}`,
                investigationProductName: isChinese ? `${investigationProductName}${secondInvestigationProductName ? `(${secondInvestigationProductName})` : ''}` : `${investigationProductEnglishName}${secondInvestigationProductEnglishName ? `（${secondInvestigationProductEnglishName}）` : ''}`,
                investigationProductStageName: `${isChinese ? investigationProductStageName : investigationProductStageEnglishName}${investigationProductStageRemark ? `（${investigationProductStageRemark}）` : ''}`,
            }
        });
        return dataSource;
    }

    showDetail = (record) => {
        this.proDetailRef.show(record);
    }

    render() {
        const { userId, canEdit, isChinese } = this.props;
        const { data, config, loading, pagination } = this.state;
        const result = config.map(item => {
            if (isChinese) {
                item.title = item.zh;
            } else {
                item.title = item.en;
            }
            return item;
        });
        canEdit && result.push(this.getOperate());
        return (
            <div>
                { isChinese && canEdit && <Button type="primary" onClick={() => this.update()}>新增</Button> }
                <div style={{ marginTop: 20 }}>
                    <ComTable
                        data={data}
                        config={result}
                        loading={loading}
                        pagination={pagination}
                        getDataSource={this.getDataSource}
                        onChange={(params) => this.handleTableChange(params)}
                    />
                </div>
                <UpdateModal ref={el => this.ref = el} userId={userId} isChinese={isChinese} loadData={this.loadData} />
                <ProDetail ref={el => this.proDetailRef = el} isChinese={isChinese} loadData={this.loadData} canEdit={canEdit}/>
            </div>
        );
    }
}

export default ClinicalTrialExp;


// WEBPACK FOOTER //
// ./src/components/common/curriculumVitae/ClinicalTrialExp.js